import { computed } from "vue";

import { i18n, translate } from "./stores/i18n.js";

export function bandLabel(band) {
  const raw = String(band || "").trim();
  if (!raw) return "";
  const slug = raw.toLowerCase().replace(/[\s-]+/g, "_");
  const key = `b_${slug}`;
  const translated = translate(key);
  return translated === key ? raw.replace(/[_-]+/g, " ") : translated;
}

export function useI18n() {
  return { t: translate, lang: computed(() => i18n.lang), bandLabel };
}
